import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class UpgradeFirmwareNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Firmware Upgrade';
        this.id = 'node_upgrade_firmware';
        this.linkedFeature = 'general';
        this.requirements = ['TPP'];

        this.files = [
            'libraries/upgrade/upgrade.tbh',
            'libraries/upgrade/upgrade.tbs',
        ];

        this.inputs = [
            {
                name: 'Start',
                portId: 'upgrade_start',
                params: [
                    {
                        name: 'URL',
                        dataType: TibboDataType.STRING,
                        default: '',
                    },
                ],
            },
        ];
    }

    getDependencies() {
        const dependencies = [
            'http',
            'firmware_upgrade',
        ];
        return dependencies;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const NAME = `${this.getSettingValue('NAME')}_delay`;
        const DELAY = this.getSettingValue('DELAY');
        const links = project.getNodeLinks(this, 'upgrade_start');

        for (let i = 0; i < links.length; i += 1) {
            const link = links[0];
            const UPGRADE_URL = project.getNodeParameter(link, 'URL');
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: `upgrade_${link.getID()}`,
                template: `
    UPGRADE_URL=${UPGRADE_URL}
    device_firmware_upload_async(PL_FW_UPG_WEB, http_request_item.socket)
    http_request(HTTP_GET, UPGRADE_URL, current_interface,"")`,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return `
##### Firmware Upgrade
This block initiates a firmware upgrade. The firmware file is downloaded from the specified URL and then uploaded to the device, which is then flashed.

A .TCU file is required for an upgrade. 
<a href="https://apps.tibbo.com/tc_generator/" target="_blank">Generate a TCU file here.</a>
`;
    }
}
